import { DateUtils } from '@web_opxp/features';
import { convertFromCETStringToUTCTimestamp } from '../base/dateUtils';
import {
  MED_BANNER_CLOSE_TIMEOUT,
  MED_BANNER_SHOW_TIMEOUT,
  MED_BANNER_SUBSCRIPTION_CREATED_TIMEOUT_SEC,
} from './constants';

function setShowTimestamp(timestamp: number) {
  localStorage.setItem('med-banner-dashboard-show-timestamp', `${timestamp}`);
}

function getMedBannerShowTimestamp() {
  const lsTimestampValue = localStorage.getItem('med-banner-dashboard-show-timestamp');
  return lsTimestampValue === null ? 0 : Number(lsTimestampValue);
}

function getMedBannerCloseTimestamp() {
  const lsTimestampValue = localStorage.getItem('med-banner-dashboard-close-timestamp');
  return lsTimestampValue === null ? 0 : Number(lsTimestampValue);
}

export function closeMedBanner() {
  // write timestamp to close value
  localStorage.setItem('med-banner-dashboard-close-timestamp', `${Date.now()}`);
}

export function isBannerCanBeShown() {
  const now = Date.now();
  const closeTimestamp = getMedBannerCloseTimestamp();
  const showTimestamp = getMedBannerShowTimestamp();
  if (closeTimestamp === 0 && showTimestamp === 0) {
    // banner was neither shown nor closed
    setShowTimestamp(now);
    return true;
  }
  if (closeTimestamp >= showTimestamp) {
    // last action - banner was closed
    const closeCondition = now - closeTimestamp >= MED_BANNER_CLOSE_TIMEOUT;
    if (closeCondition) {
      // if we are going to show the banner - update show banner timestamp
      setShowTimestamp(now);
    }
    return closeCondition;
  }
  // last action was showing the banner
  const showCondition = now - showTimestamp <= MED_BANNER_SHOW_TIMEOUT;
  if (!showCondition) {
    // if we are hiding banner and it was not the last action - save the close timestamp
    closeMedBanner();
  }
  return showCondition;
}

export function subscriptionIsOlderThanAMonth(createdAt?: string) {
  if (!createdAt) {
    return false;
  }
  // current timestamp in UTC
  const now = DateUtils.getUnixTimestamp();
  // subscription creation timestamp in UTC
  const createdTimestamp = convertFromCETStringToUTCTimestamp(createdAt);
  return now - createdTimestamp >= MED_BANNER_SUBSCRIPTION_CREATED_TIMEOUT_SEC;
}
